export default "__VITE_ASSET__D6lr5HbL__"